import React from 'react';
import './SearchBarArea.css';

function SearchBarArea() {
  return (
    <div className="search-area">
      <div className="search-container">
        <div className="search-box">
          <input 
            type="text" 
            className="search-input" 
            placeholder="Search for an item on Swapwise HK"
          />
          
          <div className="location-dropdown">
            <select className="location-select">
              <option value="all">All of Hong Kong</option>
              <option value="hong-kong-island">Hong Kong Island</option>
              <option value="kowloon">Kowloon</option>
              <option value="new-territories">New Territories</option>
            </select>
          </div>
          
          <button className="search-button">
            <svg xmlns="http://www.w3.org/2000/svg" className="search-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
            Search
          </button>
        </div>
      </div>
    </div>
  );
}

export default SearchBarArea; 